import productWaitlistController from './productWaitlistController'

export default productWaitlistController



// WEBPACK FOOTER //
// ../src/controllers/productWaitlistController/index.js